export function isOneTapAllowed(pageType?: string): boolean {
    if (!pageType || typeof pageType !== 'string') return false;
    const t = pageType.toLowerCase();
    return t === 'home' || t === 'srp' || t === 'vip';
}

export default isOneTapAllowed;


